import type { Locale, SearchHouse } from 'lc-services/types'

export const useListHouses = (housesIds: string[], loadPeriod = false) => {
  const {
    $lcServicesSearch: { searchController, searchPresenter },
  } = useNuxtApp()
  const i18n = useI18n<unknown, Locale>()
  const { currency } = useUser()
  const { algoliaIds } = useAuth()
  const { bookingPeriod } = useHouseInquiryBooking()

  const { data: houses } = useAsyncData(
    `houses-${housesIds.join('-')}`,
    async () => {
      await searchController.searchHousesV2(
        {
          housesIds,
          initializelist: true,
          itemsPerPage: Math.min(housesIds.length, 12),
          mode: 'client',
          period:
            loadPeriod && bookingPeriod.value
              ? {
                  startDate: bookingPeriod.value[0],
                  endDate: bookingPeriod.value[1],
                }
              : undefined,
          prices: [0, 100000],
        },
        i18n.locale.value,
        currency.value,
        algoliaIds.value,
        'web',
      )
      return searchPresenter.vm.searchHousesResult
    },
    {
      default: () => [] as SearchHouse[],
      watch: loadPeriod ? [currency, bookingPeriod] : [currency],
    },
  )

  return { houses }
}
